<template>
  <div id="app" class="">
    <router-view></router-view>  
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld
  },
  data() {
    return {
      
    }
  },
  created() {
    // console.log(this.$router);
  },
}
</script>
<style lang="sass" scoped>
::v-deep body{
  background-color: #f3f4f6;
}
[type=button], [type=reset], [type=submit], button{
  background-color:none;
}
</style>